export default {
  title: "عدم امکان دسترسی با موبایل",
  desc: "لطفا برای استفاده از این برنامه، با رایانه رومیزی وارد شوید.",
};
